var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Paper, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
var GridPesquisar = function (props) {
    var filtrarGrid = props.filtrarGrid, maxLength = props.maxLength, onPesquisar = props.onPesquisar;
    var _a = React.useState(''), Texto = _a[0], setTexto = _a[1]; // Provide a default value of an empty string
    var getTextoTratado = function (texto) {
        if (!maxLength)
            return texto;
        return texto.slice(0, maxLength);
    };
    var executarFiltro = function () {
        filtrarGrid(getTextoTratado(Texto));
        onPesquisar === null || onPesquisar === void 0 ? void 0 : onPesquisar();
    };
    var handleKeyPress = function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            executarFiltro();
        }
    };
    return (_jsxs(Paper, __assign({ component: 'form', onSubmit: function (event) {
            event.preventDefault();
            executarFiltro();
        }, sx: { p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', minWidth: 0, overflow: 'hidden' } }, { children: [_jsx(InputBase, { value: Texto, onChange: function (e) {
                    var novoTexto = getTextoTratado(e.target.value);
                    setTexto(novoTexto);
                    if (novoTexto === '')
                        filtrarGrid('');
                }, onKeyDown: handleKeyPress, sx: {
                    ml: 1,
                    flex: 1,
                    minWidth: 0,
                    '& .MuiInputBase-input': {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    },
                }, placeholder: 'Pesquisar', inputProps: { 'aria-label': 'Pesquisar', maxLength: maxLength }, 
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true }), _jsx(IconButton, __assign({ type: 'button', sx: { p: '10px' }, "aria-label": 'search', onClick: executarFiltro }, { children: _jsx(SearchIcon, {}) }))] })));
};
export default GridPesquisar;
